{
  "welcome": "Bem-vindo ao Harmonia",
  "landing": {
    "nav": {
      "brand": "Harmonia",
      "install": "Instalar",
      "cta": "Participar"
    },
    "installHints": {
      "ios": {
        "title": "Instalar Harmonia",
        "step1": "1. Toque no ícone Compartilhar do Safari",
        "step2": "2. Escolha \"Adicionar à Tela de Início\"",
        "step3": "3. Confirme com \"Adicionar\"",
        "close": "Entendi"
      },
      "firefox": {
        "title": "Instalar Harmonia",
        "step1": "1. Abra o menu (≡) do Firefox",
        "step2": "2. Escolha \"Instalar\" ou \"Adicionar à Tela de Início\"",
        "step3": "3. Confirme a instalação",
        "close": "Entendi"
      },
      "generic": {
        "title": "Instalar Harmonia",
        "step1": "1. Abra o menu do seu navegador",
        "step2": "2. Procure \"Instalar aplicativo\" ou \"Adicionar à Tela de Início\"",
        "step3": "3. Confirme a instalação",
        "close": "Entendi"
      }
    },
    "hero": {
      "pill": "Central de Talentos",
      "titleLine1": "Revele",
      "titleLine2": "seu",
      "titleHighlight": "talento",
      "titleLine3": "ao mundo",
      "sub": "A plataforma criada para inspirar, conectar e impulsionar criadores, gamers e inovadores.",
      "statDisciplines": "Disciplinas",
      "statConcours": "Concursos",
      "statTrophees": "Troféus ao vivo",
      "badgeTrophees": "Troféus",
      "badgeLive": "Ao vivo",
      "badgeCommunaute": "Comunidade",
      "ctaMain": "Começar a aventura",
      "ctaInstall": "Instalar o app",
      "ctaSecondary": "Explorar o universo"
    },
    "market": {
  "chip": "SOLUÇÃO PRO",
  "titleLine1": "A sua loja,",
  "titleLine2": "o seu site, o seu mundo",
  "sub": "Comerciantes, artesãos, empreendedores: crie a sua loja na Harmonia e tenha um verdadeiro site, personalizável e acessível em todo o mundo — tanto na plataforma como fora dela.",
  "feature1Title": "Site completo e personalizável",
  "feature1Desc": "Cada loja transforma-se num site completo, à sua imagem: layout, apresentação e identidade visual.",
  "feature2Title": "Um link URL para a sua loja",
  "feature2Desc": "Partilhe a sua loja onde quiser através de um link público funcional, sem que os seus clientes precisem de ter uma conta.",
  "feature3Title": "Um link URL por produto",
  "feature3Desc": "Cada produto tem a sua própria página completa e o seu próprio link, pronto para ser partilhado em todas as suas redes sociais.",
  "feature4Title": "Presente em todo o lado, venda em todo o lado",
  "feature4Desc": "Publique, apresente os seus produtos e interaja com os seus clientes em todas as plataformas, onde quer que estejam no mundo.",
  "statBoutiques": "Lojas ativas",
  "statProduits": "Produtos publicados",
  "statMonde": "Acessível em todo o mundo",
  "cta": "Criar a minha loja"
},
    "vision": {
      "chip": "NOSSA VISÃO",
      "titleLine1": "Uma harmonia",
      "titleLine2": "planetária",
      "sub": "Acreditamos que o talento não tem fronteiras. Harmonia é o espaço onde suas ideias ganham vida, apoiadas por uma energia coletiva sem precedentes.",
      "card1Title": "Criatividade livre",
      "card1Desc": "Um espaço acolhedor criado para dar asas à sua imaginação, sem barreiras.",
      "card2Title": "Conexões fortes",
      "card2Desc": "Conheça mentes apaixonadas, colabore em projetos inéditos e cresça em conjunto.",
      "card3Title": "Evolução constante",
      "card3Desc": "Cerque-se de uma energia positiva que impulsiona cada pessoa a se superar todos os dias."
    },
    "disciplines": {
      "chip": "NOSSAS DISCIPLINAS",
      "titleLine1": "Escolha",
      "titleLine2": "seu palco",
      "sub": "Concursos ativos distribuídos em várias disciplinas. Enfrente seus amigos, mostre do que é capaz — e conquiste troféus entregues publicamente diante de toda a comunidade. Toda semana, novos desafios.",
      "statDisciplines": "Disciplinas",
      "statConcours": "Concursos",
      "statHebdo": "Semanal",
      "trophyBanner": "Seu talento merece ser visto · Sua vitória merece ser celebrada",
      "hint": "Toque em uma disciplina para começar",
      "ctaTrophies": "Troféus · Entregues publicamente",
      "strategie": {
        "label": "Jogos de Estratégia",
        "tagline": "Pura reflexão e tática",
        "desc": "Enfrente seus adversários em duelos intensos de estratégia. Cada vitória te aproxima do pódio.",
        "item1Name": "Awalé",
        "item1Sub": "A arte ancestral da estratégia",
        "item2Name": "Damas",
        "item2Sub": "Domine o tabuleiro"
      },
      "connaissance": {
        "label": "Conhecimentos",
        "tagline": "Teste seu saber",
        "desc": "Duelos intelectuais tão emocionantes quanto imprevisíveis. O conhecimento no topo merece sua coroa.",
        "item1Name": "Verdadeiro ou Falso",
        "item1Sub": "Desafie seus amigos com fatos"
      },
      "arts": {
        "label": "Artes",
        "tagline": "Criatividade e expressão",
        "desc": "Seu olhar, seu traço, seu estilo. Exponha suas criações e receba o reconhecimento que merecem.",
        "item1Name": "Fotografia",
        "item1Sub": "Seu olhar, sua assinatura",
        "item2Name": "Desenho",
        "item2Sub": "Seu traço, seu universo",
        "item3Name": "Design",
        "item3Sub": "A estética a serviço da intenção"
      },
      "performance": {
        "label": "Performance",
        "tagline": "Suba ao palco",
        "desc": "Incorpore, cative, transcenda. O palco da Harmonia aguarda sua consagração.",
        "item1Name": "Comédia",
        "item1Sub": "O riso, a arte mais universal",
        "item2Name": "Dança",
        "item2Sub": "Cada movimento conta uma história",
        "item3Name": "Teatro",
        "item3Sub": "Incorpore, cative, transcenda"
      },
      "musique": {
        "label": "Música",
        "tagline": "Faça o palco vibrar",
        "desc": "Sua voz, seus instrumentos, sua marca no mundo. As grandes vozes merecem sua ovação.",
        "item1Name": "Canto",
        "item1Sub": "Sua voz, seu instrumento precioso",
        "item2Name": "Piano",
        "item2Sub": "88 teclas, um universo infinito",
        "item3Name": "Violão",
        "item3Sub": "Cada acorde, uma declaração"
      },
      "artisanat": {
        "label": "Artesanato",
        "tagline": "Excelência no ofício",
        "desc": "Ofícios nobres, maestria rara. A excelência artesanal merece seu pódio e reconhecimento.",
        "item1Name": "Costura",
        "item1Sub": "A arte que veste o mundo",
        "item2Name": "Marcenaria",
        "item2Sub": "A madeira em suas mãos se torna obra",
        "item3Name": "Cabeleireiro",
        "item3Sub": "Sublimar, transformar, revelar",
        "item4Name": "Solda",
        "item4Sub": "A precisão que une os metais",
        "item5Name": "Mecânica",
        "item5Sub": "A ciência que faz o mundo girar"
      }
    },
    "challenge": {
      "chip": "DESAFIOS & CONCURSOS",
      "title": "Concursos para você brilhar",
      "sub": "Cada disciplina abre a porta para concursos semanais. Estratégia, artes, música, performance, artesanato — sua área de excelência com certeza tem sua competição na Harmonia.",
      "subMobile": "Cada disciplina abre a porta para concursos semanais. Sua área de excelência tem sua competição na Harmonia.",
      "cta": "Aceitar um desafio"
    },
    "community": {
      "chip": "COMUNIDADE",
      "titleLine1": "Uma família",
      "titleLine2": "inspiradora",
      "sub": "Junte-se a um mosaico de talentos. Esteja aqui para compartilhar uma obra, encontrar inspiração ou construir o futuro, você encontrará seu lugar.",
      "cta": "Entrar na comunidade"
    },
    "final": {
      "titleLine1": "Seu momento",
      "titleLine2": "chegou",
      "sub": "Não deixe seu potencial esperando por mais tempo.\nFaça sua voz ressoar hoje mesmo.",
      "cta": "Criar meu perfil criativo",
      "note": "A aventura começa aqui · Acesso imediato · Gratuito"
    },
    "footer": {
      "tagline": "Vamos cultivar a inspiração, juntos.",
      "copyright": "Todos os direitos reservados"
    }
  },
  "login": {
    "common": {
      "tagline": "Revele Seu Talento",
      "or": "ou",
      "continueWithGoogle": "Continuar com Google",
      "needHelp": "Precisa de ajuda?",
      "loading": "Carregando...",
      "emailPlaceholder": "Email",
      "passwordPlaceholder": "Senha"
    },
    "login": {
      "title": "Entrar",
      "subtitle": "Bem-vindo! Entre para continuar",
      "forgotPassword": "Esqueceu a senha?",
      "submit": "Entrar",
      "noAccountPrefix": "Ainda não tem conta?",
      "noAccountLink": "Criar conta"
    },
    "signup": {
      "title": "Cadastro",
      "subtitle": "Crie sua conta Harmonia",
      "lastNamePlaceholder": "Sobrenome",
      "firstNamePlaceholder": "Nome",
      "passwordPlaceholder": "Senha (mín. 6 caracteres)",
      "submit": "Criar minha conta",
      "alreadyAccountPrefix": "Já tem uma conta?",
      "alreadyAccountLink": "Entrar"
    },
    "verify": {
      "title": "Verifique seu email",
      "subtitle": "Um link de confirmação foi enviado para",
      "step1": "Verifique sua caixa de entrada",
      "step2": "Clique no link de confirmação",
      "step3": "Volte aqui e clique em \"Verificar\"",
      "submit": "Verificar ativação",
      "backToSignup": "Voltar ao cadastro"
    },
    "reset": {
      "title": "Esqueceu a senha",
      "subtitle": "Digite seu email para receber um link de redefinição",
      "submit": "Enviar link",
      "backToLogin": "Voltar ao login",
      "confirm": {
        "checkingLink": "Verificando o link...",
        "title": "Nova senha",
        "subtitle": "Escolha uma nova senha segura para sua conta.",
        "newPasswordPlaceholder": "Nova senha",
        "confirmPasswordPlaceholder": "Confirmar senha",
        "submit": "Redefinir minha senha",
        "backToLogin": "Voltar ao login",
        "backToLoginArrow": "← Voltar ao login",
        "invalidLink": {
          "title": "Link inválido",
          "subtitle": "Este link é inválido ou expirou.\nPor favor, solicite uma nova redefinição de senha."
        },
        "messages": {
          "fillBothFields": "Por favor, preencha os dois campos",
          "passwordTooShort": "A senha deve ter pelo menos 6 caracteres",
          "passwordsDoNotMatch": "As senhas não coincidem",
          "resetting": "Redefinindo...",
          "resetError": "Erro ao redefinir a senha",
          "passwordChanged": "Senha alterada com sucesso!",
          "cannotResetPassword": "Não foi possível redefinir a senha"
        }
      }
    },
    "confirmGoogle": {
      "title": "Confirmar identidade",
      "subtitle": "Continuar como",
      "submit": "Continuar",
      "cancel": "Cancelar"
    },
    "terms": {
      "prefix": "Li e aceito os ",
      "cgu": "Termos de Uso",
      "middle": ", a ",
      "privacy": "Política de Privacidade",
      "and": " e as ",
      "community": "Regras da Comunidade"
    },
    "google": {
      "defaultUser": "Usuário"
    },
    "messages": {
      "mustAcceptTerms": "Você deve aceitar os termos de uso para continuar",
      "fillAllFields": "Por favor, preencha todos os campos",
      "passwordTooShort": "A senha deve ter pelo menos 6 caracteres",
      "invalidDate": "Formato de data inválido",
      "registrationsClosed": "As inscrições estão fechadas no momento.",
      "cannotVerifyRegistrations": "Não foi possível verificar as inscrições.",
      "cannotReachServer": "Não foi possível contatar o servidor.",
      "creatingAccount": "Criando conta...",
      "signupError": "Erro durante o cadastro",
      "accountCreated": "Conta criada! Verifique seu email.",
      "cannotCreateAccount": "Não foi possível criar a conta",
      "verifying": "Verificando...",
      "verificationError": "Erro de verificação",
      "emailVerified": "Email verificado! Bem-vindo à Harmonia!",
      "emailNotVerified": "Email não verificado. Clique no link do seu email.",
      "cannotVerifyEmail": "Não foi possível verificar o email",
      "enterEmailPassword": "Por favor, digite seu email e senha",
      "loggingIn": "Entrando...",
      "emailNotConfirmed": "Email não confirmado. Verifique sua caixa de entrada.",
      "incorrectCredentials": "Credenciais incorretas",
      "loginSuccess": "Login realizado com sucesso! Bem-vindo!",
      "cannotLogin": "Não foi possível entrar",
      "enterEmail": "Por favor, digite seu email",
      "sendingEmail": "Enviando email...",
      "noAccountWithEmail": "Nenhuma conta com este email",
      "resetRequestError": "Erro ao processar a solicitação",
      "linkSent": "Link enviado! Verifique sua caixa de entrada.",
      "cannotSendEmail": "Não foi possível enviar o email",
      "googleWebFailed": "Login do Google na web falhou",
      "googleTokenMissing": "Token de autenticação do Google ausente",
      "googleCancelled": "Login do Google cancelado",
      "googleFailed": "O login do Google não pôde ser concluído",
      "googleInProgress": "Login do Google já em andamento",
      "playServicesUnavailable": "Os serviços do Google Play não estão disponíveis",
      "googleError": "Erro durante o login do Google",
      "certifyingIdentity": "Certificando sua identidade...",
      "googleServerValidationFailed": "Falha na validação do Google no servidor",
      "welcomeUser": "Bem-vindo, {{name}}!",
      "googleFinalizeError": "Não foi possível finalizar o login do Google"
    }
  },
  "guide": {
    "header": {
      "title": "Guia de uso",
      "gotIt": "Entendi!"
    },
    "guides": {
      "create": {
        "tabLabel": "Criar",
        "title": "Criar minha conta Harmonia",
        "step1": "Toque em \"Criar conta\" na parte inferior da tela de login.",
        "step2": "Informe seu sobrenome, nome e data de nascimento.",
        "step3": "Digite um endereço de email válido.",
        "step4": "Escolha uma senha com pelo menos 6 caracteres.",
        "step5": "Marque a caixa para aceitar os Termos de Uso, a Política de Privacidade e as Regras da Comunidade.",
        "step6": "O botão \"Criar minha conta\" fica ativo — toque nele.",
        "step7": "Verifique sua caixa de entrada e clique no link de confirmação recebido.",
        "step8": "Volte ao app e toque em \"Verificar ativação\" para finalizar."
      },
      "login": {
        "tabLabel": "Entrar",
        "title": "Entrar na Harmonia",
        "step1": "Digite seu endereço de email no primeiro campo.",
        "step2": "Digite sua senha no segundo campo.",
        "step3": "Use o ícone 👁 para mostrar ou ocultar sua senha.",
        "step4": "Toque no botão \"Entrar\".",
        "step5": "Você será redirecionado para seu espaço Harmonia!"
      },
      "reset": {
        "tabLabel": "Senha esquecida",
        "title": "Esqueceu a senha",
        "step1": "Na tela de login, toque em \"Esqueceu a senha?\".",
        "step2": "Digite o endereço de email vinculado à sua conta Harmonia.",
        "step3": "Toque em \"Enviar link\".",
        "step4": "Verifique sua caixa de entrada (verifique também o spam!).",
        "step5": "Clique no link de redefinição recebido por email.",
        "step6": "Defina sua nova senha e depois faça login.",
        "note": "⏱ O link expira rapidamente. Aja assim que receber o email!"
      },
      "google": {
        "tabLabel": "Google",
        "title": "Entrar com o Google",
        "step1": "Toque em \"Continuar com Google\" na tela de login ou cadastro.",
        "step2": "Selecione sua conta Google na janela que se abre.",
        "step3": "Verifique as informações exibidas e toque em \"Continuar\".",
        "step4": "Você está conectado à Harmonia!",
        "note": "💡 Para o cadastro via Google, marque primeiro os Termos de Uso antes de tocar no botão do Google."
      },
      "verify": {
        "tabLabel": "Email",
        "title": "Verificação do email",
        "step1": "Após o cadastro, um email de confirmação é enviado automaticamente.",
        "step2": "Abra sua caixa de entrada e verifique também o spam / lixo eletrônico.",
        "step3": "Clique no botão \"Confirmar meu email\" no email recebido.",
        "step4": "Volte ao aplicativo Harmonia.",
        "step5": "Toque em \"Verificar ativação\" para finalizar seu cadastro.",
        "note": "⚠️ O link é válido por 24 horas. Se expirar, recomece o cadastro desde o início."
      }
    }
  },
  "notifications": {
    "header": {
      "subtitle": "Central de notificações"
    },
    "tabs": {
      "notifs": "Notificações",
      "last24h": "Info 24h",
      "trophees": "Troféus"
    },
    "time": {
      "now": "Agora mesmo",
      "minutes_one": "{{count}} min",
      "minutes_other": "{{count}} min",
      "hours_one": "{{count}}h",
      "hours_other": "{{count}}h",
      "days_one": "{{count}}d",
      "days_other": "{{count}}d"
    },
    "types": {
      "friendRequest": "Pedido de amizade",
      "friendAccepted": "Amizade aceita",
      "like": "Curtida",
      "comment": "Comentário",
      "report": "Denúncia",
      "postStatus": "Status",
      "default": "Anúncio"
    },
    "error": {
      "notConnected": "Não conectado",
      "generic": "Erro {{status}}",
      "retry": "Tentar novamente"
    },
    "loading": {
      "default": "Carregando…",
      "info24h": "Carregando…",
      "info24hFull": "Carregando as últimas 24 horas…"
    },
    "markAll": {
      "action": "Marcar tudo como lido"
    },
    "empty": {
      "notifs": {
        "title": "Nenhuma notificação",
        "sub": "Você será informado das atividades aqui."
      },
      "last24h": {
        "title": "Nenhuma atividade recente",
        "sub": "Nenhuma notificação registrada nas últimas 24 horas."
      },
      "trophees": {
        "title": "Nenhum troféu",
        "sub": "Participe das sessões para conquistar alguns!"
      }
    },
    "more": {
      "loadOlder": "Carregar mais antigas"
    },
    "end": {
      "upToDate": "Você está em dia"
    },
    "info24h": {
      "title": "Atividade das últimas 24h",
      "count_one": "{{count}} notificação recente",
      "count_other": "{{count}} notificações recentes",
      "unread_one": "{{count}} não lida",
      "unread_other": "{{count}} não lidas"
    },
    "card": {
      "grouped_one": "{{count}} evento agrupado",
      "grouped_other": "{{count}} eventos agrupados"
    },
    "trophy": {
      "won_one": "troféu conquistado",
      "won_other": "troféus conquistados",
      "awardedBy": "Concedido por {{firstName}} {{lastName}}"
    }
  },
  "editPostModal": {
    "errors": {
      "sessionNotFound": "Sessão não encontrada",
      "accessTokenMissing": "access_token ausente"
    },
    "deleteConfirm": {
      "title": "Excluir a publicação?",
      "text": "Esta ação é irreversível. A publicação será excluída permanentemente.",
      "cancel": "Cancelar",
      "confirm": "Excluir"
    },
    "menu": {
      "title": "Opções da publicação",
      "edit": "Editar",
      "delete": "Excluir",
      "cancel": "Cancelar"
    },
    "edit": {
      "title": "Editar publicação",
      "placeholder": "O que há de novo?",
      "save": "Salvar"
    }
  },
  "logoutModal": {
    "errors": {
      "sessionNotFound": "Sessão não encontrada"
    },
    "memory": {
      "title": "Memorizar esta conta?",
      "message": "Deseja memorizar esta conta para entrar mais rápido na próxima vez, sem digitar sua senha novamente?",
      "no": "Não",
      "yes": "Sim"
    },
    "confirm": {
      "title": "Sair da conta?",
      "message": "Tem certeza de que deseja sair da sua conta?",
      "cancel": "Cancelar",
      "submit": "Sair"
    }
  },
  "commentsModal": {
    "errors": {
      "sessionNotFound": "Sessão não encontrada",
      "accessTokenMissing": "access_token ausente",
      "sendError": "Erro ao enviar",
      "title": "Erro",
      "networkError": "Erro de rede, tente novamente",
      "networkErrorTitle": "Erro de rede",
      "tryAgain": "Por favor, tente novamente"
    },
    "time": {
      "now": "Agora mesmo",
      "minutes_one": "há {{count}}min",
      "minutes_other": "há {{count}}min",
      "hours_one": "há {{count}}h",
      "hours_other": "há {{count}}h",
      "days_one": "há {{count}}d",
      "days_other": "há {{count}}d"
    },
    "likesCount_one": "{{count}} curtida",
    "likesCount_other": "{{count}} curtidas",
    "liked": "Curtido",
    "like": "Curtir",
    "reply": "Responder",
    "header": {
      "title": "Comentários"
    },
    "empty": {
      "title": "Nenhum comentário",
      "subtitle": "Seja o primeiro a comentar!"
    },
    "replyingTo": "Respondendo a {{name}}",
    "replyPlaceholder": "Responder a {{name}}...",
    "addPlaceholder": "Adicionar um comentário..."
  },
  "groupsTab": {
    "time": {
      "now": "Agora mesmo",
      "minutes_one": "{{count}}min",
      "minutes_other": "{{count}}min",
      "hours_one": "{{count}}h",
      "hours_other": "{{count}}h",
      "days_one": "{{count}}d",
      "days_other": "{{count}}d"
    },
    "loadingData": "Carregando dados",
    "tabs": {
      "mine_one": "Meus grupos ({{count}})",
      "mine_other": "Meus grupos ({{count}})",
      "explore": "Explorar"
    },
    "empty": {
      "noResults": "Nenhum resultado",
      "noResultsFor": "Nenhum grupo para \"{{query}}\"",
      "noGroups": "Você não está em nenhum grupo",
      "exploreCta": "Explorar grupos",
      "noGroupsAvailable": "Nenhum grupo disponível"
    },
    "lastMessage": "{{sender}}: {{content}}",
    "memberCount_one": "{{count}} membro",
    "memberCount_other": "{{count}} membros",
    "you": "Você",
    "open": "Abrir",
    "join": "Entrar",
    "joining": "..."
  },
  "infoBanner": {
    "previous": "Anterior",
    "next": "Próximo",
    "closeAndResume": "Fechar e retomar",
    "news": "Notícia",
    "reduceAndResume": "Minimizar e retomar a leitura"
  },
  "pushPromptModal": {
    "title": "Fique por dentro!",
    "subtitle": "Receba os anúncios importantes, seus troféus e as novas sessões da Harmonia diretamente no seu dispositivo.",
    "icons": {
      "trophies": "Troféus",
      "announcements": "Anúncios",
      "sessions": "Sessões"
    },
    "enableButton": "Ativar notificações",
    "dismissButton": "Ignorar ({{count}}s)"
  },
  "savedPostsModal": {
    "time": {
      "now": "Agora mesmo",
      "minutes_one": "há {{count}}min",
      "minutes_other": "há {{count}}min",
      "hours_one": "há {{count}}h",
      "hours_other": "há {{count}}h",
      "days_one": "há {{count}}d",
      "days_other": "há {{count}}d"
    },
    "header": {
      "title": "Posts salvos"
    },
    "syncing": "Sincronizando…",
    "tapToPlay": "Toque para reproduzir",
    "commentsCount_one": "{{count}} comentário",
    "commentsCount_other": "{{count}} comentários",
    "sharesCount_one": "{{count}} compartilhamento",
    "sharesCount_other": "{{count}} compartilhamentos",
    "empty": {
      "title": "Nenhum post salvo",
      "subtitle": "Os posts que você salvar aparecerão aqui"
    }
  },
  "sharersModal": {
    "time": {
      "now": "Agora mesmo",
      "minutes_one": "há {{count}}min",
      "minutes_other": "há {{count}}min",
      "hours_one": "há {{count}}h",
      "hours_other": "há {{count}}h",
      "days_one": "há {{count}}d",
      "days_other": "há {{count}}d"
    },
    "errors": {
      "sessionExpired": "Sessão expirada",
      "loadFailed": "Não foi possível carregar os compartilhamentos"
    },
    "sharedAt": "Compartilhado {{time}}",
    "header": {
      "title": "Compartilhamentos",
      "titleWithCount": "Compartilhamentos ({{count}})"
    },
    "loading": "Carregando...",
    "retry": "Tentar novamente",
    "empty": "Nenhum compartilhamento ainda"
  },
  "searchModal": {
    "time": {
      "now": "Agora mesmo",
      "minutes_one": "há {{count}}min",
      "minutes_other": "há {{count}}min",
      "hours_one": "há {{count}}h",
      "hours_other": "há {{count}}h",
      "days_one": "há {{count}}d",
      "days_other": "há {{count}}d"
    },
    "categories": {
      "all": "Tudo",
      "posts": "Publicações",
      "images": "Imagens",
      "videos": "Vídeos",
      "music": "Música",
      "artisanat": "Artesanato"
    },
    "tapToPlay": "Toque para reproduzir",
    "commentsCount_one": "{{count}} comentário",
    "commentsCount_other": "{{count}} comentários",
    "sharesCount_one": "{{count}} compartilhamento",
    "sharesCount_other": "{{count}} compartilhamentos",
    "status": {
      "submissions": "Envios",
      "votingOpen": "Votação aberta",
      "finished": "Encerrado"
    },
    "media": {
      "image": "imagem",
      "track": "faixa",
      "video": "vídeo",
      "hide": "Ocultar",
      "viewCount_one": "Ver {{count}} {{label}}",
      "viewCount_other": "Ver {{count}} {{label}}s"
    },
    "runNumber": "Run #{{number}}",
    "voted": "Votado",
    "vote": "Votar",
    "votesCount_one": "{{count}} voto",
    "votesCount_other": "{{count}} votos",
    "header": {
      "title": "Pesquisar"
    },
    "placeholder": "Palavras-chave, descrições, títulos…",
    "searchButton": "Pesquisar",
    "searching": "Pesquisando…",
    "noResults": {
      "title": "Nenhum resultado",
      "subtitle": "Tente outras palavras-chave"
    },
    "resultsCount_one": "{{count}} resultado",
    "resultsCount_other": "{{count}} resultados",
    "intro": {
      "title": "Pesquisar na Harmonia",
      "subtitle": "Publicações, vídeos, imagens, sons…\nEscolha uma categoria e digite suas palavras-chave"
    }
  },
  "userProfileView": {
    "time": {
      "now": "Agora mesmo",
      "minutes_one": "há {{count}}min",
      "minutes_other": "há {{count}}min",
      "hours_one": "há {{count}}h",
      "hours_other": "há {{count}}h",
      "days_one": "há {{count}}d",
      "days_other": "há {{count}}d"
    },
    "tapToPlay": "Toque para reproduzir",
    "commentsCount_one": "{{count}} comentário",
    "commentsCount_other": "{{count}} comentários",
    "sharesCount_one": "{{count}} compartilhamento",
    "sharesCount_other": "{{count}} compartilhamentos",
    "loading": "Carregando...",
    "profileNotFound": "Perfil não encontrado",
    "retry": "Tentar novamente",
    "memberSince": "Membro desde {{date}}",
    "friendsLabel": "Amigos",
    "trophiesLabel": "Troféus",
    "friend": {
      "add": "Adicionar amigo",
      "pending": "Pendente",
      "accept": "Aceitar",
      "remove": "Remover amigo"
    },
    "viewPosts": "Ver publicações",
    "postsCount": "Publicações ({{count}})",
    "noPosts": "Nenhuma publicação",
    "notFriend": {
      "pendingSent": "Solicitação enviada — Aguardando confirmação",
      "pendingReceived": "Aceite a solicitação para ver as publicações",
      "none": "Adicione este usuário como amigo para ver suas publicações"
    }
  },
  "cgu": {
    "title": "Termos Gerais de Uso",
    "stats": {
      "sections": "Seções",
      "law": "Direito beninense",
      "compliant": "Em conformidade"
    },
    "sections": {
      "presentation": {
        "title": "Apresentação da plataforma",
        "p1": "Harmonia é uma plataforma social mundial, disponível na web e no celular, que permite aos seus membros criar um perfil, publicar conteúdo, interagir por mensagens e grupos, participar de concursos de talentos, jogar jogos de cultura geral e estratégia, e criar uma loja online para usuários PRO.",
        "p2": "Harmonia é desenvolvida e operada por uma entidade registrada no Benin.",
        "highlight1": "Ao acessar a plataforma e criar uma conta, você aceita sem ressalvas estes Termos de Uso."
      },
      "inscription": {
        "title": "Acesso e cadastro",
        "sub1": "Criação de conta",
        "p1": "O acesso às funcionalidades da Harmonia exige a criação de uma conta. O cadastro está aberto a qualquer pessoa no mundo, sem restrição de idade.",
        "bullets1": [
          "Cadastro direto: sobrenome, nome, endereço de email e data de nascimento",
          "Via provedor terceiro (Google, Facebook, etc.): sobrenome, nome e endereço de email. A data de nascimento pode ser preenchida posteriormente."
        ],
        "sub2": "Exatidão das informações",
        "p2": "Você se compromete a fornecer informações precisas e atualizadas ao se cadastrar. A Harmonia não pode ser responsabilizada por consequências decorrentes de informações imprecisas.",
        "sub3": "Permanecer conectado",
        "highlight1": "Você pode optar por permanecer conectado à sua conta sem digitar novamente sua senha a cada abertura do aplicativo. Essa escolha é exclusivamente sua e pode ser alterada a qualquer momento.",
        "sub4": "Menores de idade",
        "highlight2": "Para qualquer assinatura de serviço pago (assinatura, concurso pago, loja pro), um usuário menor de idade deve obter o consentimento explícito de seu pai, mãe ou responsável legal antes de qualquer compra."
      },
      "publications": {
        "title": "Publicações e conteúdo",
        "sub1": "Limite diário",
        "bullets1": [
          "Usuários padrão: 1 publicação por dia",
          "Usuários PRO: 3 publicações por dia"
        ],
        "p1": "Esse limite incentiva a qualidade e a relevância dos conteúdos compartilhados na plataforma.",
        "sub2": "Níveis de visibilidade",
        "bullets2": [
          "PRO — visível para toda a comunidade Harmonia (recurso pago)",
          "Amigos — visível apenas para seus amigos",
          "Amigos de amigos — visível para seus amigos e os amigos deles",
          "Privado — visível apenas para você"
        ],
        "sub3": "Conteúdo proibido",
        "bullets3": [
          "Conteúdo sexual explícito ou nudez",
          "Conteúdo de ódio, discriminatório ou que incite à violência",
          "Informações falsas deliberadas e mal-intencionadas",
          "Violação dos direitos de propriedade intelectual de terceiros",
          "Conteúdo ilegal nos termos das leis aplicáveis"
        ],
        "sub4": "Propriedade intelectual",
        "highlight1": "Você mantém a propriedade total do seu conteúdo. A Harmonia não reivindica nenhum direito sobre suas criações e nunca as usará para fins promocionais sem o seu consentimento.",
        "sub5": "Responsabilidade",
        "p2": "Cada usuário é o único e total responsável pelos conteúdos que publica. A Harmonia se isenta de qualquer responsabilidade pelos conteúdos publicados por seus membros."
      },
      "abonnements": {
        "title": "Assinaturas e pagamentos",
        "sub1": "Recursos pagos",
        "bullets1": [
          "Visibilidade PRO: divulgar uma publicação para toda a comunidade",
          "Criação de uma loja pro e publicação de produtos associados",
          "Consumo de dados para fins pessoais",
          "Participação em concursos pagos"
        ],
        "sub2": "Meios de pagamento",
        "p1": "A Harmonia aceita vários meios de pagamento: pagamento móvel, cartão bancário e outros meios integrados progressivamente.",
        "sub3": "Política de não reembolso",
        "highlight1": "Toda compra é definitiva. Uma vez que um serviço tenha sido concedido e utilizado, nenhum reembolso será efetuado, mesmo em caso de suspensão do conteúdo, da loja pro ou de um produto por violação das regras."
      },
      "messagerie": {
        "title": "Mensagens e interações",
        "sub1": "Mensagens privadas",
        "p1": "As mensagens privadas são estritamente confidenciais e acessíveis apenas aos participantes de cada conversa.",
        "sub2": "Grupos de discussão",
        "p2": "A Harmonia disponibiliza grupos de discussão comunitários. Dentro desses grupos, os usuários também podem se escrever em privado.",
        "highlight1": "As regras de respeito e cortesia também se aplicam às mensagens privadas."
      },
      "publicite": {
        "title": "Publicidade",
        "p1": "Ao usar a Harmonia, você concorda em receber publicações publicitárias integradas na plataforma.",
        "highlight1": "Esses anúncios provêm exclusivamente de usuários que assinaram um plano publicitário da Harmonia. Nenhuma rede de anúncios externa é utilizada."
      },
      "concours": {
        "title": "Concursos de talentos",
        "sub1": "Áreas cobertas",
        "bullets1": [
          "Artes visuais: desenho, fotografia",
          "Artes cênicas: comédia, dança",
          "Música: piano e outros instrumentos",
          "Saber-fazer: atividades artesanais e ofícios",
          "Jogos de estratégia: damas, Awalé e outros",
          "Cultura geral: Verdadeiro ou Falso e outros formatos"
        ],
        "highlight1": "A Harmonia não oferece nenhum jogo de azar. O objetivo exclusivo é recompensar talentos reais.",
        "sub2": "Sistema de votação",
        "p1": "A passagem para a etapa presencial é determinada pelos votos da comunidade. O voto é gratuito, aberto a todos os usuários autenticados e limitado a um único voto por candidato.",
        "sub3": "Etapa presencial final",
        "p2": "As finais podem ser realizadas em qualquer lugar do mundo. Os países anfitriões e os júris especializados são selecionados aleatoriamente pela Harmonia para garantir a equidade. As recompensas incluem troféus, prêmios em dinheiro, presentes e outras distinções anunciadas para cada concurso.",
        "sub4": "Informação em tempo real",
        "highlight2": "Todos os usuários recebem informações em tempo real sobre o andamento dos concursos e sobre a atividade da plataforma, para que todos sejam informados de forma equitativa."
      },
      "boutiques": {
        "title": "Lojas pro",
        "sub1": "Descrição do serviço",
        "p1": "Os usuários PRO podem criar uma loja na plataforma, acessível a partir da Harmonia e por meio de um link URL público funcional na web. Eles podem personalizar o design e diversas configurações do site associado à sua loja.",
        "highlight1": "Cada produto publicado em uma loja também possui seu próprio link web que permite sua consulta direta.",
        "sub2": "Propriedade e responsabilidade",
        "p2": "O usuário PRO mantém a propriedade do conteúdo de sua loja e é o único e total responsável por ele, inclusive perante as pessoas que consultarem seus links web fora da Harmonia.",
        "sub3": "Conformidade e suspensão",
        "p3": "O conteúdo da loja e dos produtos está sujeito às mesmas regras que o restante da plataforma (conteúdo proibido, regras da comunidade). A Harmonia pode suspender uma loja, um produto ou desativar um link web em caso de não conformidade, sem direito a reembolso."
      },
      "moderation": {
        "title": "Moderação e denúncia",
        "sub1": "Denúncia",
        "p1": "Qualquer usuário pode denunciar um conteúdo contrário às regras, incluindo o conteúdo de uma loja pro ou de um produto publicado. Quando um conteúdo recebe um número significativo de denúncias, ele passa automaticamente para estado de análise e deixa de ser visível publicamente.",
        "sub2": "Decisão dos administradores",
        "bullets1": [
          "Conteúdo em conformidade: recupera sua visibilidade normal",
          "Conteúdo não conforme: é suspenso definitivamente e sem possibilidade de recurso"
        ],
        "highlight1": "A Harmonia não realiza banimento de usuários. As medidas de moderação incidem sobre os conteúdos, não sobre as pessoas."
      },
      "api": {
        "title": "Proteção da API e dos sistemas",
        "p1": "A API backend da Harmonia e o conjunto de seus sistemas técnicos são propriedade exclusiva da plataforma. O acesso à API é estritamente reservado às aplicações oficiais da Harmonia.",
        "sub1": "Atos proibidos",
        "bullets1": [
          "Acessar a API fora das aplicações oficiais",
          "Contornar os mecanismos de autenticação ou segurança",
          "Interceptar as trocas entre as aplicações e os servidores",
          "Utilizar robôs, scripts automatizados ou ferramentas de scraping",
          "Realizar ataques DDoS ou qualquer ação que perturbe a plataforma",
          "Explorar falhas técnicas para fins maliciosos",
          "Reproduzir ou redistribuir dados provenientes da plataforma"
        ],
        "sub2": "Ações judiciais",
        "highlight1": "Toda violação constitui uma infração grave passível de ações judiciais. A Harmonia cooperará com as autoridades competentes de qualquer país para identificar e processar os infratores.",
        "sub3": "Notificação responsável",
        "p2": "Se você descobrir uma falha de segurança, notifique imediatamente harmonia@harmoniaworld.world sem explorá-la. A Harmonia tratará toda notificação de boa-fé de maneira séria e confidencial."
      },
      "disponibilite": {
        "title": "Disponibilidade da plataforma",
        "p1": "A Harmonia se esforça para garantir uma disponibilidade ideal. Podem ocorrer interrupções por motivos de manutenção, atualização ou circunstâncias técnicas alheias à nossa vontade.",
        "p2": "A Harmonia não pode ser responsabilizada por essas interrupções."
      },
      "modifications": {
        "title": "Modificação dos Termos de Uso",
        "p1": "A Harmonia se reserva o direito de modificar estes Termos de Uso a qualquer momento. Os usuários serão informados de qualquer modificação substancial por meio da plataforma.",
        "highlight1": "A continuação do uso após a modificação implica a aceitação das novas condições."
      },
      "droit": {
        "title": "Lei aplicável e jurisdição",
        "p1": "Estes Termos de Uso são regidos pela lei beninense. Em caso de litígio, e na falta de resolução amigável, os tribunais competentes do Benin serão acionados."
      },
      "contact": {
        "title": "Contato",
        "p1": "Para qualquer guia de uso da plataforma, consulte nossa documentação disponível diretamente na Harmonia."
      }
    }
  },
  "confidentialite": {
    "title": "Política de Privacidade",
    "stats": {
      "sections": "Seções",
      "gdpr": "Em conformidade com o RGPD",
      "secure": "Dados seguros"
    },
    "sections": {
      "intro": {
        "title": "Introdução",
        "p1": "Harmonia é uma plataforma social mundial disponível na web e no celular, que permite aos seus usuários publicar conteúdo, interagir, participar de concursos e jogar jogos de cultura geral e estratégia.",
        "p2": "Esta Política de Privacidade informa você de forma transparente sobre os dados que coletamos, como os utilizamos, seus direitos e as medidas adotadas para proteger sua privacidade.",
        "highlight1": "Ao usar a Harmonia, você aceita as práticas descritas nesta política."
      },
      "responsable": {
        "title": "Responsável pelo tratamento",
        "p1": "O responsável pelo tratamento dos dados pessoais coletados pela Harmonia é a equipe de liderança da plataforma Harmonia, entidade registrada no Benin.",
        "p2": "Para qualquer dúvida relacionada aos seus dados pessoais, ao exercício de seus direitos, ou para qualquer reclamação, entre em contato conosco diretamente por este endereço."
      },
      "donnees": {
        "title": "Dados coletados",
        "sub1": "Cadastro direto",
        "bullets1": [
          "Sobrenome e nome",
          "Endereço de email",
          "Data de nascimento"
        ],
        "sub2": "Via provedor terceiro (Google, Facebook, etc.)",
        "bullets2": [
          "Sobrenome e nome",
          "Endereço de email",
          "Data de nascimento (a ser preenchida posteriormente)"
        ],
        "sub3": "Dados de perfil e conteúdo publicado",
        "p1": "Você controla a visibilidade de cada informação do seu perfil e de cada publicação (PRO, Amigos, Amigos de amigos, Privado).",
        "sub4": "Mensagens",
        "p2": "As mensagens privadas e discussões em grupo são estritamente confidenciais, acessíveis apenas aos participantes de cada conversa.",
        "sub5": "Dados de pagamento",
        "p3": "Tratados exclusivamente por nossos provedores certificados. A Harmonia nunca armazena diretamente seus dados bancários.",
        "sub6": "Lojas pro",
        "highlight1": "Os usuários PRO podem criar uma loja com um link URL público. Coletamos as informações da loja, os produtos publicados (cada um com seu próprio link web) e os dados de personalização do site associado."
      },
      "utilisation": {
        "title": "Uso dos dados",
        "bullets1": [
          "Gestão da sua conta e autenticação",
          "Recursos sociais (publicações, mensagens, amigos, grupos)",
          "Concursos, jogos e etapas finais presenciais mundiais",
          "Divulgação em tempo real de informações sobre os concursos e a atividade da plataforma",
          "Gestão das suas assinaturas e serviços pagos",
          "Criação e disponibilização das lojas pro e dos links web associados",
          "Aplicação dos limites de publicação diários (1/dia padrão, 3/dia PRO) para reforçar a qualidade da informação",
          "Anúncios internos provenientes de usuários assinantes",
          "Segurança, prevenção de fraudes e moderação de conteúdo"
        ],
        "highlight1": "Nos comprometemos a nunca vender, alugar ou transmitir seus dados a terceiros para fins comerciais."
      },
      "concours": {
        "title": "Concursos e eventos presenciais",
        "p1": "Alguns concursos culminam em uma etapa final presencial organizada pela Harmonia que pode ocorrer em qualquer lugar do mundo.",
        "highlight1": "A Harmonia não coleta nenhum dado adicional para esses eventos. Nenhum documento de identidade, endereço ou localização é solicitado.",
        "p2": "Os júris especializados e os países anfitriões são selecionados aleatoriamente pela Harmonia para garantir a equidade e prevenir fraudes.",
        "sub1": "Informação em tempo real",
        "p3": "A Harmonia divulga em tempo real informações sobre o andamento dos concursos, a partir de dados já coletados no contexto normal de uso da plataforma. Essa divulgação não gera nenhuma coleta de dados adicional."
      },
      "publicite": {
        "title": "Publicidade",
        "p1": "Ao usar a Harmonia, você concorda em receber publicações publicitárias provenientes exclusivamente de usuários assinantes de um plano publicitário da Harmonia.",
        "highlight1": "Nenhuma rede de anúncios externa. Nenhuma publicidade de terceiros externos é veiculada na Harmonia."
      },
      "securite": {
        "title": "Hospedagem e segurança",
        "p1": "Seus dados são hospedados em servidores localizados na Europa, em conformidade com as normas de segurança vigentes.",
        "bullets1": [
          "Criptografia de dados sensíveis",
          "Acesso restrito aos dados conforme os perfis",
          "Monitoramento contínuo da infraestrutura",
          "Limitação do número de publicações diárias, para prevenir comportamentos abusivos"
        ],
        "sub1": "Proteção da API e dos sistemas técnicos",
        "p2": "A API backend da Harmonia é reservada para uso interno exclusivo. Qualquer acesso não autorizado é proibido e passível de ações judiciais. A Harmonia coleta os registros técnicos (conexões, endereços IP) para detectar e processar qualquer acesso fraudulento."
      },
      "partage": {
        "title": "Compartilhamento de dados",
        "highlight1": "Seus dados nunca são compartilhados para fins comerciais ou publicitários externos.",
        "bullets1": [
          "Fornecedores técnicos sujeitos a obrigações contratuais estritas de confidencialidade",
          "Obrigações legais (procedimento judicial ou requisição de autoridade competente)"
        ],
        "p1": "O conteúdo de uma loja pro (produtos, descrição, personalização) é disponibilizado publicamente por meio de seu link web assim que o usuário PRO opta por publicar sua loja."
      },
      "mineurs": {
        "title": "Usuários menores de idade",
        "p1": "A Harmonia é acessível a todos os usuários sem restrição de idade. O talento não tem idade e o conhecimento é para todos.",
        "highlight1": "Para qualquer serviço pago, um menor de idade deve obter o consentimento explícito de seu pai, mãe ou responsável legal."
      },
      "droits": {
        "title": "Seus direitos (RGPD)",
        "bullets1": [
          "Direito de acesso — consultar seus dados",
          "Direito de retificação — corrigir dados imprecisos",
          "Direito ao apagamento — excluir sua conta e seus dados",
          "Direito à portabilidade — exportar seus dados",
          "Direito de oposição — a determinados tratamentos",
          "Direito de retirar o consentimento a qualquer momento"
        ],
        "highlight1": "Para exercer seus direitos: harmonia@harmoniaworld.world"
      },
      "conservation": {
        "title": "Conservação dos dados",
        "p1": "Seus dados são conservados durante todo o período de uso ativo da plataforma.",
        "bullets1": [
          "Dados identificáveis excluídos ao encerrar a conta",
          "Dados anonimizados podem ser conservados para fins estatísticos",
          "Loja pro e produtos associados excluídos ao encerrar a conta; os links web associados deixam de funcionar"
        ]
      },
      "cookies": {
        "title": "Cookies e tecnologias de rastreamento",
        "highlight1": "Nenhuma ferramenta de rastreamento de terceiros (sem Google Analytics nem rastreadores publicitários).",
        "p1": "Apenas cookies técnicos essenciais são utilizados (sessão, autenticação, segurança). No celular, tokens de autenticação seguros são armazenados localmente no seu dispositivo, inclusive quando você opta por permanecer conectado."
      },
      "responsabilite": {
        "title": "Responsabilidade dos usuários",
        "p1": "Cada usuário é o único e total responsável pelos conteúdos que publica na Harmonia, incluindo o conteúdo de uma loja pro e seus links web associados.",
        "p2": "A Harmonia se reserva o direito de suspender todo conteúdo não conforme após análise por seus administradores, incluindo uma loja pro ou um produto publicado."
      },
      "modifications": {
        "title": "Modificações da política",
        "p1": "A Harmonia se reserva o direito de modificar esta política a qualquer momento. Em caso de modificação substancial, os usuários serão notificados por meio da plataforma.",
        "highlight1": "A continuação do uso após a modificação implica a aceitação das novas condições."
      },
      "contact": {
        "title": "Contato",
        "p1": "Consulte também nosso guia de uso disponível diretamente na Harmonia."
      }
    }
  },
  "guideScreen": {
    "header": {
      "title": "Guia de uso",
      "subtitle": "Tudo sobre a Harmonia"
    },
    "intro": {
      "text": "Bem-vindo ao guia de uso. Toque em um capítulo para expandi-lo e descobrir como usar cada recurso.",
      "allMembers": "Todos os membros",
      "proFeatures": "Funções PRO"
    },
    "chapters": {
      "compte": {
        "title": "Login e Conta",
        "steps": {
          "step1": {
            "title": "Criar uma conta",
            "desc": "Na tela inicial, toque em \"Criar conta\". Informe seu nome, sobrenome, endereço de email e uma senha. Marque os termos de uso e toque em \"Cadastrar\"."
          },
          "step2": {
            "title": "Verificar seu email",
            "desc": "Após o cadastro, um email de verificação é enviado a você. Abra-o e clique no link para ativar sua conta, depois volte ao aplicativo."
          },
          "step3": {
            "title": "Entrar",
            "desc": "Digite seu email e senha, depois toque em \"Entrar\"."
          },
          "step4": {
            "title": "Permanecer conectado",
            "desc": "Você pode optar por permanecer conectado à sua conta. Nesse caso, toda vez que abrir o aplicativo, você chegará diretamente ao feed sem precisar digitar sua senha novamente. Essa escolha é sua a qualquer momento: se você sair explicitamente sem ter ativado essa opção, verá a tela de login na próxima abertura do aplicativo."
          },
          "step5": {
            "title": "Esqueceu a senha",
            "desc": "Na tela de login, toque em \"Esqueceu a senha\". Digite seu email. Você receberá um código de 6 dígitos. Digite-o e crie uma nova senha."
          },
          "step6": {
            "title": "Login com Google",
            "desc": "Toque em \"Continuar com Google\" para se conectar em um clique. No primeiro login, você precisará aceitar os termos de uso."
          }
        }
      },
      "actu": {
        "title": "Feed de notícias",
        "steps": {
          "step1": {
            "title": "Navegar no feed",
            "desc": "A aba Feed 🏠 exibe as publicações da comunidade. Role para baixo para carregar mais conteúdo. Toque no ícone de filtro para ordenar: Tudo · Publicações · Imagens · Vídeos · Música."
          },
          "step2": {
            "title": "Ocultar ou exibir o cabeçalho",
            "desc": "Toque duas vezes na área do cabeçalho para ocultá-lo e ganhar espaço de leitura. Repita para exibi-lo novamente."
          },
          "step3": {
            "title": "Seu saldo CFA",
            "desc": "Seu saldo CFA é exibido no cabeçalho. Toque nele para abrir diretamente a tela de recarga e adicionar fundos via Mobile Money."
          },
          "step4": {
            "title": "Atualizar o feed",
            "desc": "Deslize para baixo a partir do topo do feed para atualizar. Você também pode tocar no ícone de atualização 🔄 no cabeçalho."
          },
          "step5": {
            "title": "Criar uma publicação",
            "desc": "Toque no botão \"+\" no cabeçalho. Escreva sua mensagem (máx. 1.000 caracteres). Escolha a visibilidade: Público · Amigos · Privado · PRO. Toque em \"Publicar\"."
          },
          "step6": {
            "title": "Adicionar uma foto ou vídeo à publicação",
            "desc": "Os membros PRO podem anexar uma foto ou vídeo às suas publicações. Um botão 📷 Foto e 🎬 Vídeo aparece no formulário de criação."
          },
          "step7": {
            "title": "Curtir uma publicação",
            "desc": "Toque no polegar 👍 abaixo de uma publicação para curtir. Um brilho roxo se anima. Toque novamente para desfazer. Toque no contador de curtidas para ver a lista de pessoas que curtiram."
          },
          "step8": {
            "title": "Comentar",
            "desc": "Toque no ícone 💬 para abrir os comentários da publicação. Escreva sua resposta na caixa de texto na parte inferior e envie."
          },
          "step9": {
            "title": "Compartilhar uma publicação",
            "desc": "Toque no ícone de compartilhamento 🔄 para compartilhar uma publicação pública no feed. Toque no número de compartilhamentos exibido para ver a lista de usuários que compartilharam."
          },
          "step10": {
            "title": "Salvar uma publicação",
            "desc": "Toque no ícone 🔖 abaixo de uma publicação para salvá-la. Encontre todos os seus salvos tocando no ícone dedicado no cabeçalho."
          },
          "step11": {
            "title": "Denunciar conteúdo",
            "desc": "Toque no ícone de denúncia ⚠️ para denunciar uma publicação inadequada à equipe da Harmonia."
          },
          "step12": {
            "title": "Editar ou excluir suas publicações",
            "desc": "Em suas próprias publicações, um ícone ✏️ permite editar o texto e um ícone 🗑️ permite excluir. Esses botões só aparecem em suas próprias publicações."
          },
          "step13": {
            "title": "Ver uma imagem ampliada",
            "desc": "Toque em uma imagem no feed para abri-la. Toque duas vezes para exibi-la em tela cheia. Toque novamente para fechar."
          },
          "step14": {
            "title": "Reproduzir um vídeo ou áudio",
            "desc": "As publicações de vídeo exibem um botão ▶️. As submissões musicais têm um player integrado com Play/Pause e barra de progresso. Toque em ❤️ para votar."
          },
          "step15": {
            "title": "Votar nas criações do feed",
            "desc": "As submissões artísticas e de performance aparecem no feed. Role verticalmente para navegar por vídeos estilo TikTok. Toque em ❤️ para votar no seu favorito."
          },
          "step16": {
            "title": "Pesquisar no feed",
            "desc": "Toque no ícone 🔍 no cabeçalho para abrir a barra de pesquisa e encontrar publicações ou usuários."
          },
          "step17": {
            "title": "Notificações",
            "desc": "Toque no ícone 🔔 no cabeçalho para consultar suas notificações (curtidas, comentários, pedidos de amizade, etc.)."
          }
        }
      },
      "jeux": {
        "title": "Central de Talentos",
        "steps": {
          "step1": {
            "title": "Explorar as disciplinas",
            "desc": "A aba Jogos 🎮 abre a Central de Talentos com 6 categorias: Jogos de Estratégia · Conhecimentos · Artes · Performance · Música · Artesanato. Role para ver todas."
          },
          "step2": {
            "title": "Descobrir um jogo em detalhes",
            "desc": "Mantenha pressionado (≈ 0,4 s) qualquer jogo para abrir sua ficha: descrição, tagline e selo de troféu. Toque em \"Começar a aventura\" ou feche a ficha."
          },
          "step3": {
            "title": "Abrir um jogo",
            "desc": "Toque normalmente em um jogo para abri-lo em tela cheia. O botão ⓘ no cabeçalho exibe o banner de apresentação da Harmonia."
          },
          "step4": {
            "title": "Entrar em uma sessão",
            "desc": "Em cada jogo, a aba \"Explorar\" lista as sessões disponíveis (gratuitas ou pagas em CFA). Toque em \"Participar\" para entrar. A aba \"Minhas Sessões\" exibe as que você já entrou."
          },
          "step5": {
            "title": "Verdadeiro ou Falso — Responder a uma pergunta",
            "desc": "Aba Sessões → escolha uma sessão → um grupo. Toque em \"Responder\". A pergunta aparece com uma barra de progresso. Toque em \"VERDADEIRO\" (verde) ou \"FALSO\" (vermelho). Navegue entre as perguntas com Anterior / Próxima."
          },
          "step6": {
            "title": "Verdadeiro ou Falso — Grupos bloqueados",
            "desc": "Alguns grupos exigem uma pontuação mínima para acesso. Se sua pontuação for insuficiente, o grupo exibe um ícone 🔒 e a pontuação necessária."
          },
          "step7": {
            "title": "Verdadeiro ou Falso — Ver suas respostas",
            "desc": "A aba \"Respostas\" permite consultar as perguntas que você respondeu e sua escolha VERDADEIRO/FALSO, sem ver as pontuações."
          },
          "step8": {
            "title": "Verdadeiro ou Falso — Resultados",
            "desc": "A aba \"Resultados\" exibe suas pontuações e as respostas corretas. Essas informações só aparecem quando o administrador as revela. Antes disso, uma mensagem \"Aguardando\" é exibida."
          },
          "step9": {
            "title": "Awalé e Damas — Entrar e jogar",
            "desc": "Escolha uma sessão em \"Minhas Sessões\". Quando o run é iniciado, toque em \"Jogar agora\". Uma contagem regressiva de preparação precede cada partida. Você sempre aparece na parte inferior do tabuleiro."
          },
          "step10": {
            "title": "Damas — Jogar no tabuleiro",
            "desc": "Toque em uma de suas peças para selecioná-la — as casas válidas se iluminam em verde (movimento) ou laranja (captura possível). Toque na casa de destino para jogar. As damas ♔ podem se mover em todas as direções."
          },
          "step11": {
            "title": "Awalé — Jogar no tabuleiro",
            "desc": "Seus buracos (linha inferior) se iluminam em verde quando é sua vez. Toque em um buraco com sementes para jogar. A pontuação é exibida no topo. Em caso de empate, uma rodada decisiva \"Primeiro a 12\" começa automaticamente."
          },
          "step12": {
            "title": "Classificação das partidas (Awalé e Damas)",
            "desc": "A aba \"Classificação\" lista suas sessões. Toque em uma sessão para ver os runs e os resultados de cada partida (em andamento 🔵 ou finalizada ✅) com o vencedor destacado 🏆."
          },
          "step13": {
            "title": "Enviar uma criação — Artes",
            "desc": "Aba \"Enviar\" → escolha um run aberto. Preencha cada slot com uma imagem (JPG · PNG · WEBP). Adicione uma descrição se desejar. O botão de envio fica ativo quando todos os slots estão preenchidos."
          },
          "step14": {
            "title": "Enviar — Performance e Artesanato",
            "desc": "Mesmo princípio das Artes, mas com vídeos (MP4 · MOV · WEBM). Todos os slots devem ser preenchidos. As criações já enviadas ficam bloqueadas e exibem o ícone 🔒."
          },
          "step15": {
            "title": "Enviar — Música",
            "desc": "Selecione seus arquivos de áudio (MP3 · WAV · M4A) da sua galeria. Preencha todos os slots exigidos, adicione uma descrição opcional e envie."
          },
          "step16": {
            "title": "Classificação criativa e Votos",
            "desc": "A aba \"Classificação\" exibe o pódio 🥇🥈🥉 com o número de votos ❤️ de cada participante. Ela é atualizada assim que os votos são abertos pelo administrador."
          }
        }
      },
      "messages": {
        "title": "Mensagens",
        "steps": {
          "step1": {
            "title": "Histórico de conversas",
            "desc": "A aba Histórico 🕐 lista suas conversas privadas e em grupo. Um selo vermelho indica mensagens não lidas. A prévia da última mensagem exibe um emoji conforme o tipo: 📷 Foto · 🎬 Vídeo · 🎵 Áudio · 📁 Arquivo."
          },
          "step2": {
            "title": "Amigos online",
            "desc": "A aba \"Online\" 🟢 exibe seus amigos atualmente conectados (ponto verde). Toque em um amigo para iniciar uma conversa diretamente."
          },
          "step3": {
            "title": "Meus amigos",
            "desc": "A aba \"Amigos\" 👥 lista todos os seus amigos (online ou offline). Toque em um nome para abrir a conversa."
          },
          "step4": {
            "title": "Grupos",
            "desc": "A aba \"Grupos\" exibe suas conversas em grupo. Toque em um grupo para abri-lo."
          },
          "step5": {
            "title": "Pesquisar uma conversa",
            "desc": "Toque no ícone 🔍 no cabeçalho para exibir a barra de pesquisa. Ela funciona em cada aba — Histórico, Online, Amigos e Grupos."
          },
          "step6": {
            "title": "Sincronização manual",
            "desc": "Toque no ícone de sincronização, diretamente visível no cabeçalho \"Mensagens\", para iniciar uma sincronização. Uma animação em 3 etapas é exibida: Inicialização → Atualização → Sincronização de dados. Um retorno visual confirma o sucesso ou indica um erro."
          },
          "step7": {
            "title": "Enviar uma mensagem de texto",
            "desc": "Digite na caixa de texto (máx. 1.000 caracteres) e toque em ➤ para enviar. O status aparece abaixo da sua bolha: ⏳ enviando · ✓ enviado · ✓✓ lido."
          },
          "step8": {
            "title": "Reenviar uma mensagem com falha",
            "desc": "Se uma mensagem não pôde ser enviada após 3 tentativas, sua bolha aparece com uma borda vermelha e um botão \"Tentar novamente\" 🔁. Toque nele para reenviar."
          },
          "step9": {
            "title": "Enviar mídia (PRO)",
            "desc": "Os membros PRO veem um botão 📎 à esquerda da caixa de texto. Toque para anexar uma imagem, vídeo ou documento (PDF, Word, Excel, etc.) à sua mensagem."
          },
          "step10": {
            "title": "Gravar e enviar uma nota de voz (PRO)",
            "desc": "Quando a caixa de texto está vazia, os membros PRO veem um botão 🎤. Mantenha pressionado para gravar. Toque em ⏹ para parar. Um player de pré-visualização aparece com Play/Pause, barra de progresso e duração total. Toque em ➤ para enviar ou 🗑️ para cancelar."
          },
          "step11": {
            "title": "Responder em um grupo",
            "desc": "Mantenha pressionada uma mensagem para abrir as ações. Escolha \"Responder publicamente\" 🌍 (todo o grupo vê a resposta) ou \"Responder em privado\" 🔒 (visível apenas para você e o destinatário)."
          },
          "step12": {
            "title": "Alterar a visibilidade da sua resposta",
            "desc": "Toque duas vezes na sua própria resposta em um grupo para alternar entre pública e privada. O ícone 👁 ou 🚫👁 confirma o estado atual. Você também pode usar o toque longo → \"Tornar privada\" / \"Tornar visível\"."
          },
          "step13": {
            "title": "Excluir uma mensagem",
            "desc": "Mantenha pressionada uma de suas mensagens, depois toque em \"Excluir\". A mensagem é substituída por \"Mensagem excluída\" para todos os participantes."
          },
          "step14": {
            "title": "Ver uma imagem em tela cheia",
            "desc": "Toque duas vezes em uma imagem em uma conversa para exibi-la em tela cheia. Toque novamente ou no ✕ para fechar."
          },
          "step15": {
            "title": "Banner offline",
            "desc": "Se a conexão for perdida, um banner vermelho aparece no topo da conversa. Suas mensagens ficam em espera e são reenviadas automaticamente assim que a conexão retornar."
          }
        }
      },
      "amis": {
        "title": "Rede e Amigos",
        "steps": {
          "step1": {
            "title": "Sugestões de amigos",
            "desc": "A aba Rede 👥 exibe pessoas que você pode conhecer. Role para carregar mais sugestões. Toque no botão ➕ à direita de um nome para enviar um pedido de amizade."
          },
          "step2": {
            "title": "Pesquisar um usuário",
            "desc": "Toque na aba \"Pesquisa\" 🔍. Digite um nome ou sobrenome na barra, depois toque na seta → para iniciar a pesquisa. Toque em ➕ para enviar um pedido a um resultado."
          },
          "step3": {
            "title": "Pedidos recebidos",
            "desc": "A aba \"Pedidos\" 📩 exibe um selo vermelho se você tiver pedidos pendentes. Subaba \"Recebidos\": toque em \"Aceitar\" para se tornarem amigos, ou \"Recusar\" para declinar."
          },
          "step4": {
            "title": "Pedidos enviados",
            "desc": "Subaba \"Enviados\": encontre todos os seus pedidos aguardando resposta. Toque em \"Cancelar\" para retirar um pedido."
          },
          "step5": {
            "title": "Ver o perfil de um usuário",
            "desc": "Nas sugestões, resultados de pesquisa ou pedidos, toque no nome ou avatar de um usuário para abrir sua ficha de perfil."
          }
        }
      },
      "profil": {
        "title": "Meu Perfil",
        "steps": {
          "step1": {
            "title": "Editar a foto de perfil",
            "desc": "Na tela Perfil, toque no ícone 📷 laranja sobre seu avatar para escolher uma nova foto da sua galeria. A atualização é imediata."
          },
          "step2": {
            "title": "Saldo CFA e Troféus",
            "desc": "Dois cartões coloridos exibem seu saldo CFA 💰 e seu número de troféus 🏆 conquistados. Esses contadores são atualizados automaticamente."
          },
          "step3": {
            "title": "Recarregar o saldo",
            "desc": "Toque no cartão \"Recarregar meu saldo\" (carteira dourada) para acessar a tela de recarga. Você também pode recarregar a partir do feed tocando no seu saldo CFA."
          },
          "step4": {
            "title": "Editar suas informações",
            "desc": "Toque em \"Ajustes\" ⚙️ na seção \"Minha conta\". Um painel se abre a partir da parte inferior com os campos Sobrenome, Nome e Data de nascimento. Edite e toque em \"Salvar\"."
          },
          "step5": {
            "title": "Privacidade",
            "desc": "Toque em \"Privacidade\" 🛡️ para acessar as configurações de privacidade, dados e segurança da sua conta."
          },
          "step6": {
            "title": "Acessar o guia",
            "desc": "Toque em \"Guia de uso\" 📖 na seção \"Minha conta\" para abrir este guia a qualquer momento."
          },
          "step7": {
            "title": "Criar uma publicação a partir do perfil",
            "desc": "Na seção \"Publicações\", toque no botão \"Publicar\" (gradiente rosa-laranja). O formulário de criação se abre com as mesmas opções do feed."
          },
          "step8": {
            "title": "Gerenciar suas publicações",
            "desc": "Suas publicações são listadas na parte inferior do perfil. Em cada uma: ✏️ para editar o texto · 🗑️ para excluir (uma confirmação é solicitada). As ações de curtir, comentar, compartilhar e salvar também estão disponíveis."
          },
          "step9": {
            "title": "Adicionar mídia a uma publicação (PRO)",
            "desc": "Os membros PRO veem botões 📷 Foto e 🎬 Vídeo no formulário de criação. Uma prévia é exibida antes da publicação. Toque em ✖ para remover a mídia."
          },
          "step10": {
            "title": "Sair da conta",
            "desc": "Toque no ícone de saída 🚪 no topo direito do perfil. Uma confirmação é solicitada antes da saída efetiva. Se você tinha optado por permanecer conectado, essa saída é definitiva: você verá a tela de login na próxima abertura do aplicativo."
          }
        }
      },
      "pro": {
        "title": "Status PRO ⭐",
        "steps": {
          "step1": {
            "title": "Selo PRO visível",
            "desc": "O selo ⭐ PRO aparece no seu perfil e é visível para todos os membros da comunidade Harmonia."
          },
          "step2": {
            "title": "Publicações enriquecidas",
            "desc": "Os membros PRO podem anexar uma foto ou vídeo às suas publicações no feed de notícias. Publicações com visibilidade \"PRO\" só são visíveis para outros membros PRO."
          },
          "step3": {
            "title": "Mídia nas mensagens",
            "desc": "Como membro PRO, você pode enviar imagens, vídeos e documentos (PDF, Word, Excel, etc.) em conversas privadas e em grupo."
          },
          "step4": {
            "title": "Notas de voz",
            "desc": "Os membros PRO podem gravar e enviar notas de voz nas mensagens. Um player de pré-visualização integrado permite ouvir a gravação antes de enviá-la."
          },
          "step5": {
            "title": "Passar para o status PRO",
            "desc": "Toque em \"Recarregar meu saldo\" no seu perfil ou no seu saldo CFA no feed. Recarregue sua conta via Mobile Money para acessar os recursos PRO."
          }
        }
      },
      "market": {
        "title": "Loja Pro e Market ⭐",
        "steps": {
          "step1": {
            "title": "Abrir o Market",
            "desc": "Um 6º botão \"Market\" 🛍️ está disponível na barra de navegação principal. Toque nele: a barra rola e dá lugar a uma nova barra de navegação dedicada ao Market, com 4 botões: Home, Todos os produtos, Lojas e Ajustes."
          },
          "step2": {
            "title": "Voltar à navegação principal",
            "desc": "A partir do Market, toque no botão \"Home\" 🏠 para voltar à barra de navegação principal do aplicativo."
          },
          "step3": {
            "title": "Navegar por todos os produtos",
            "desc": "O botão \"Todos os produtos\" exibe o conjunto de produtos publicados pelas lojas da plataforma, de todos os vendedores."
          },
          "step4": {
            "title": "Navegar pelas lojas",
            "desc": "O botão \"Lojas\" exibe a lista de lojas criadas pelos membros PRO na Harmonia."
          },
          "step5": {
            "title": "Criar sua loja e site (PRO)",
            "desc": "Como membro PRO, o botão \"Ajustes\" ⚙️ do Market permite criar sua própria loja. A Harmonia então gera um verdadeiro site para sua loja, acessível por meio de um link URL público funcional na web, além de estar visível diretamente na plataforma."
          },
          "step6": {
            "title": "Personalizar o site da sua loja (PRO)",
            "desc": "A partir de \"Ajustes\", personalize o design e diversas configurações do site da sua loja: apresentação, layout e outros elementos visuais, para que se pareça com você."
          },
          "step7": {
            "title": "Publicar produtos (PRO)",
            "desc": "Ainda em \"Ajustes\", adicione e atualize os produtos da sua loja. Cada produto publicado tem automaticamente seu próprio link web, que permite consultá-lo e compartilhá-lo diretamente."
          },
          "step8": {
            "title": "Gerenciar as lojas seguidas",
            "desc": "Em \"Ajustes\", encontre a lista de lojas que você segue. Você pode deixar de seguir uma loja a qualquer momento nesta tela."
          },
          "step9": {
            "title": "Encontrar seus produtos salvos",
            "desc": "Ainda em \"Ajustes\", consulte a lista de produtos que você salvou durante sua navegação no Market."
          }
        }
      }
    }
  },
  "politiqueCookies": {
    "title": "Política de Cookies",
    "stats": {
      "sections": "Seções",
      "zeroTracking": "Zero rastreamento",
      "essentialOnly": "Apenas cookies essenciais"
    },
    "sections": {
      "definition": {
        "title": "O que é um cookie?",
        "p1": "Um cookie é um pequeno arquivo de texto colocado no seu dispositivo (computador, tablet, smartphone) durante a navegação. Ele permite que a plataforma memorize certas informações para melhorar sua experiência.",
        "highlight1": "Os cookies não podem danificar seu dispositivo e não contêm vírus."
      },
      "politique": {
        "title": "A Harmonia e os cookies",
        "p1": "A Harmonia adota uma política estrita e minimalista em relação aos cookies.",
        "highlight1": "Não utilizamos nenhum cookie para fins publicitários externos, de perfilamento ou de rastreamento por terceiros.",
        "p2": "Nenhuma ferramenta de análise externa (como o Google Analytics) é utilizada. Seus dados de navegação nunca são transmitidos a parceiros publicitários externos."
      },
      "utilises": {
        "title": "Cookies que utilizamos",
        "p1": "A Harmonia utiliza apenas cookies técnicos estritamente necessários para o bom funcionamento da plataforma.",
        "sub1": "Cookies de sessão e autenticação",
        "p2": "Permitem mantê-lo conectado à sua conta Harmonia. Criados ao abrir sua sessão, são excluídos por padrão ao encerrá-la.",
        "highlight1": "Você pode optar por permanecer conectado: nesse caso, um token de autenticação persistente é mantido para evitar digitar novamente sua senha. Essa escolha é sua e pode ser modificada a qualquer momento.",
        "sub2": "Cookies relacionados a provedores terceiros (Google, etc.)",
        "p3": "Ao se conectar via Google ou outro provedor, este pode colocar seus próprios cookies como parte do processo de autenticação. Esses são regidos por sua própria política de privacidade.",
        "sub3": "Cookies de segurança",
        "p4": "Contribuem para a proteção da sua conta contra tentativas de fraude e acesso não autorizado.",
        "sub4": "Cookies relacionados a pagamentos",
        "p5": "Durante uma transação (assinatura, concurso pago, loja pro), os provedores de pagamento podem colocar cookies técnicos limitados à duração da transação para garantir sua segurança."
      },
      "nonUtilises": {
        "title": "Cookies NÃO utilizados",
        "p1": "Por total transparência, eis o que a Harmonia não utiliza:",
        "bullets1": [
          "Cookies publicitários — nenhuma publicidade externa, nenhuma segmentação",
          "Cookies de rastreamento analítico de terceiros — nenhuma ferramenta externa de análise",
          "Cookies de perfilamento comportamental — nenhum perfil publicitário construído"
        ]
      },
      "mobile": {
        "title": "Aplicativo móvel",
        "p1": "No aplicativo móvel da Harmonia, cookies no sentido estrito não são utilizados. Tecnologias semelhantes (tokens de autenticação seguros, armazenamento local) são empregadas para garantir o bom funcionamento.",
        "highlight1": "Se você optar por permanecer conectado, um token de autenticação é mantido localmente no seu dispositivo. Você continua no controle dessa escolha e pode sair a qualquer momento para removê-lo.",
        "p2": "Esses dados são armazenados apenas no seu dispositivo e nunca são compartilhados com terceiros para fins publicitários."
      },
      "duree": {
        "title": "Período de conservação",
        "bullets1": [
          "Cookie de sessão — excluído ao encerrar a sessão",
          "Cookie de autenticação — duração da sua sessão ativa, ou até a desconexão explícita se \"permanecer conectado\" estiver ativado",
          "Cookie de segurança — duração da sua sessão ativa",
          "Cookie de pagamento — apenas durante a transação"
        ]
      },
      "gestion": {
        "title": "Gerenciamento dos seus cookies",
        "sub1": "Pelo seu navegador",
        "bullets1": [
          "Google Chrome: Configurações › Privacidade e segurança › Cookies",
          "Mozilla Firefox: Configurações › Privacidade e segurança › Cookies",
          "Safari: Preferências › Privacidade › Cookies",
          "Microsoft Edge: Configurações › Privacidade › Cookies"
        ],
        "highlight1": "Atenção: desativar os cookies técnicos essenciais pode impedir sua conexão à Harmonia.",
        "sub2": "Pelo seu dispositivo móvel",
        "p1": "Gerencie as permissões do aplicativo Harmonia diretamente nas configurações do seu dispositivo iOS ou Android.",
        "sub3": "Opção \"permanecer conectado\"",
        "p2": "Tanto na web quanto no celular, essa opção é facultativa e permanece sob seu controle exclusivo. Uma desconexão manual remove o cookie ou o token associado."
      },
      "modifications": {
        "title": "Modificações da política",
        "p1": "A Harmonia se reserva o direito de modificar esta política a qualquer momento, especialmente em caso de evolução técnica ou mudança regulatória. Os usuários serão informados de qualquer modificação por meio da plataforma.",
        "highlight1": "A continuação do uso após a modificação implica a aceitação das novas condições."
      },
      "contact": {
        "title": "Contato",
        "p1": "Consulte nosso guia de uso disponível diretamente na Harmonia para qualquer dúvida adicional."
      }
    }
  },
  "reglesCommunautaires": {
    "title": "Regras da Comunidade",
    "stats": {
      "sections": "Seções",
      "forEveryone": "Para todos",
      "healthyCommunity": "Comunidade saudável"
    },
    "sections": {
      "respect": {
        "title": "Respeito e cordialidade",
        "p1": "A Harmonia é um espaço de compartilhamento e expressão. Cada membro deve tratar os outros com respeito, independentemente de sua origem, cultura, religião, gênero, idade ou opiniões.",
        "sub1": "É proibido:",
        "bullets1": [
          "Insultar, humilhar ou rebaixar outro membro",
          "Assediar, ameaçar ou intimidar uma pessoa ou grupo",
          "Fazer comentários discriminatórios ou depreciativos contra uma comunidade",
          "Incentivar ou glorificar a violência de qualquer forma"
        ]
      },
      "contenuInterdit": {
        "title": "Conteúdo proibido",
        "p1": "Os seguintes conteúdos são estritamente proibidos na Harmonia, qualquer que seja sua forma e nível de visibilidade:",
        "sub1": "Conteúdo sexual e nudez",
        "p2": "Toda publicação de caráter sexual explícito ou com nudez é proibida.",
        "sub2": "Ódio e discriminação",
        "p3": "Todo conteúdo que incite ao ódio contra uma pessoa ou grupo em razão de sua raça, etnia, religião, nacionalidade, gênero, orientação sexual ou deficiência.",
        "sub3": "Violência e conteúdo chocante",
        "p4": "Conteúdos que representem atos reais de violência, cenas de tortura, mutilação ou qualquer conteúdo suscetível de traumatizar os membros.",
        "sub4": "Desinformação",
        "p5": "É proibida a publicação deliberada de informações falsas com o objetivo de enganar, manipular ou prejudicar.",
        "sub5": "Violação de privacidade e falsidade ideológica",
        "bullets1": [
          "Publicar informações pessoais de terceiros sem seu consentimento",
          "Fazer-se passar por outra pessoa, marca ou entidade oficial"
        ]
      },
      "publications": {
        "title": "Regras de publicação",
        "sub1": "Limite diário",
        "bullets1": [
          "Usuários padrão: 1 publicação por dia",
          "Usuários PRO: 3 publicações por dia"
        ],
        "highlight1": "Esse limite reforça a qualidade das informações compartilhadas e incentiva a qualidade em detrimento da quantidade.",
        "sub2": "Autenticidade do conteúdo",
        "p1": "Você se compromete a publicar apenas conteúdo do qual seja autor ou para o qual detenha os direitos necessários.",
        "sub3": "Responsabilidade conforme a visibilidade",
        "p2": "Você é o único responsável pelo seu conteúdo, qualquer que seja o nível de visibilidade escolhido. A visibilidade PRO, acessível a toda a comunidade e incluída em seu próprio limite de 3 publicações diárias, implica uma responsabilidade maior."
      },
      "messagerie": {
        "title": "Mensagens e grupos",
        "p1": "As regras de respeito e cordialidade também se aplicam às mensagens privadas e aos grupos de discussão. O caráter privado de uma troca nunca justifica um comportamento desrespeitoso.",
        "highlight1": "É proibido o envio de mensagens não solicitadas de caráter comercial, publicitário ou de assédio."
      },
      "concours": {
        "title": "Concursos e competições",
        "sub1": "Autenticidade das participações",
        "p1": "Cada participante deve enviar apenas criações originais das quais seja autor. Toda fraude ou plágio resulta em desclassificação imediata e definitiva.",
        "sub2": "Integridade da votação",
        "bullets1": [
          "É proibido votar em troca de contrapartidas (dinheiro, serviços)",
          "É proibido usar ferramentas automatizadas para manipular os votos",
          "É proibido votar várias vezes por meio de várias contas"
        ],
        "highlight1": "Cada usuário autenticado tem direito a um único voto por candidato. Qualquer contorno resulta na suspensão dos votos correspondentes.",
        "sub3": "Respeito entre concorrentes",
        "p2": "É proibido qualquer menosprezo, zombaria ou ataque a outro participante. A competição deve permanecer saudável e respeitosa.",
        "sub4": "Jogos de estratégia e cultura geral",
        "p3": "Os jogos (damas, Awalé, Verdadeiro ou Falso…) devem ser praticados com fair-play. É proibido o uso de softwares de assistência ou qualquer meio desleal.",
        "sub5": "Informação em tempo real",
        "p4": "A Harmonia divulga em tempo real informações sobre o andamento dos concursos e a atividade da plataforma, para que todos os usuários sejam informados de forma equitativa e no mesmo momento. É proibida qualquer tentativa de manipulação ou desvio dessa divulgação."
      },
      "publicite": {
        "title": "Publicidade e conteúdo comercial",
        "p1": "Somente os usuários que assinaram um plano publicitário da Harmonia estão autorizados a publicar conteúdo publicitário na plataforma.",
        "highlight1": "É estritamente proibida toda prospecção comercial não autorizada, promoção de atividades ilegais ou divulgação de links fraudulentos."
      },
      "boutiques": {
        "title": "Lojas pro",
        "p1": "Os usuários PRO podem criar uma loja na plataforma, acessível pela Harmonia e por meio de um link URL público na web. Cada produto publicado dispõe de seu próprio link web.",
        "highlight1": "As regras relativas ao conteúdo proibido e à publicidade aplicam-se integralmente ao conteúdo de uma loja pro e de seus produtos, inclusive quando acessados por meio de um link web público.",
        "sub1": "Proibições específicas",
        "bullets1": [
          "Vender ou oferecer produtos ou serviços ilegais",
          "Publicar informações enganosas sobre os produtos oferecidos",
          "Utilizar a loja para fins de golpe ou coleta abusiva de dados dos visitantes"
        ],
        "p2": "O usuário PRO é o único responsável pelo conteúdo de sua loja. Toda loja ou produto não conforme pode ser suspenso, inclusive por meio da desativação do link web associado."
      },
      "signalement": {
        "title": "Denúncia",
        "sub1": "Como denunciar",
        "p1": "Se você notar um conteúdo que viole as regras, denuncie-o por meio da funcionalidade prevista para isso na plataforma.",
        "sub2": "Tratamento das denúncias",
        "bullets1": [
          "Limite de denúncias atingido → conteúdo em estado de análise (não visível)",
          "Conteúdo em conformidade → recupera sua visibilidade normal",
          "Conteúdo não conforme → suspenso definitivamente"
        ],
        "highlight1": "Todo uso abusivo da funcionalidade de denúncia é, em si, contrário às regras da comunidade."
      },
      "sanctions": {
        "title": "Consequências das violações",
        "sub1": "Suspensão de conteúdo",
        "p1": "Todo conteúdo considerado contrário às regras é suspenso definitivamente e sem possibilidade de recurso. A Harmonia não realiza banimento de usuários; as medidas incidem sobre os conteúdos, não sobre as pessoas.",
        "sub2": "Ausência de reembolso",
        "p2": "A suspensão de um conteúdo pago (visibilidade PRO ou loja pro) não gera nenhum reembolso.",
        "sub3": "Responsabilidade pessoal",
        "highlight1": "Em caso de infração grave às leis vigentes, a Harmonia se reserva o direito de transmitir os elementos necessários às autoridades competentes, se a lei assim o exigir."
      },
      "api": {
        "title": "Proibição de acesso à API",
        "p1": "A API backend e os sistemas técnicos da Harmonia são reservados para uso exclusivamente interno da plataforma. É estritamente proibido:",
        "bullets1": [
          "Acessar a API fora das aplicações oficiais",
          "Utilizar scripts, robôs ou ferramentas automatizadas para extrair dados",
          "Contornar os sistemas de segurança ou autenticação",
          "Interceptar as comunicações entre as aplicações e os servidores",
          "Explorar ou tentar explorar qualquer falha técnica"
        ],
        "highlight1": "Esses atos constituem infrações graves passíveis de ações judiciais. A Harmonia coopera com as autoridades competentes para identificar e processar os infratores.",
        "p2": "Toda falha descoberta deve ser notificada a harmonia@harmoniaworld.world sem ser explorada."
      },
      "evolution": {
        "title": "Evolução das regras",
        "p1": "A Harmonia se reserva o direito de atualizar essas regras a qualquer momento, em função do desenvolvimento da plataforma e das necessidades da comunidade.",
        "highlight1": "A continuação do uso após a modificação implica a aceitação das novas regras."
      },
      "contact": {
        "title": "Contato",
        "p1": "Consulte nosso guia de uso disponível diretamente na Harmonia para qualquer dúvida."
      }
    }
  },
  "actuScreen": {
    "toasts": {
      "noConnection": "Sem conexão com a internet",
      "mediaAccessRequired": "Acesso à mídia necessário.",
      "imageAdded": "Imagem adicionada!",
      "videoAdded": "Vídeo adicionado!",
      "cannotAddMedia": "Não foi possível adicionar a mídia",
      "contentRequired": "O conteúdo é obrigatório",
      "limitReached": "Limite de publicações atingido.",
      "postPublished": "Publicação publicada!",
      "cannotPublish": "Não foi possível publicar",
      "reportRegistered": "Denúncia registrada!",
      "reportError": "Erro ao enviar a denúncia",
      "networkError": "Erro de rede",
      "postSanctioned": "Publicação sancionada ({{status}})",
      "adminError": "Erro de administração"
    },
    "offlineBanner": "Sem conexão — Offline",
    "doubleTapToShow": "Toque duas vezes para exibir",
    "loading": "Carregando...",
    "upToDate": "Você está em dia ✓",
    "report": {
      "title": "Denunciar",
      "message": "Denunciar esta publicação?",
      "confirm": "Sim, denunciar",
      "cancel": "Cancelar"
    },
    "filters": {
      "all": "Tudo",
      "posts": "Publicações",
      "images": "Imagens",
      "videos": "Vídeos",
      "music": "Música"
    },
    "filterMenu": {
      "title": "Exibir"
    },
    "adminStrike": {
      "title": "Punição Direta",
      "selectSanction": "Selecione a sanção:",
      "pending": "Colocar em espera (Pendente)",
      "lock": "Bloquear (Ativo)",
      "cancel": "Cancelar"
    },
    "empty": {
      "offlineTitle": "Nenhum conteúdo offline",
      "emptyFeedTitle": "Seu feed de notícias está vazio",
      "offlineSubtitle": "Reconecte-se para carregar seu feed de notícias.",
      "emptyFeedSubtitle": "Adicione amigos para descobrir suas publicações, criações e performances.\n\nQuanto mais amigos ativos você tiver, mais animado será seu feed! 🎨"
    },
    "createPost": {
      "title": "Nova publicação",
      "placeholder": "O que há de novo?",
      "videoReady": "Vídeo pronto",
      "photo": "Foto",
      "video": "Vídeo",
      "publish": "Publicar"
    },
    "visibility": {
      "public": "Público",
      "friends": "Amigos",
      "pro": "PRO",
      "private": "Privado"
    },
    "postDetails": {
      "title": "📊 Detalhes",
      "author": "Autor:",
      "published": "Publicado:",
      "reactions": "Reações:",
      "close": "Fechar"
    }
  },
  "tabsLayout": {
    "offlineText": "Sem conexão com a internet",
    "tabs": {
      "actu": "Feed",
      "games": "Jogos",
      "market": "Market",
      "messages": "Mensagens",
      "friends": "Amigos",
      "profile": "Perfil"
    }
  },
  "gamesScreen": {
    "header": {
      "pill": "Central de Talentos",
      "title": "Revele seu Talento"
    },
    "infoBanner": {
      "title": "🏆 Harmonia — Central de Talentos",
      "text": "Bem-vindo à Harmonia, a plataforma que revela e celebra os talentos da nossa comunidade. Participe dos desafios, enfrente seus amigos, mostre do que é capaz — e conquiste troféus entregues publicamente diante de toda a comunidade. Toda semana, novos desafios, novas disciplinas, novas oportunidades de brilhar. Seu talento merece ser visto. Sua vitória merece ser celebrada. Junte-se ao movimento. Revele seu talento. A Harmonia espera por você. 🎯"
    },
    "chooseDiscipline": "ESCOLHA SUA DISCIPLINA",
    "longPressHint": "Toque e segure em um jogo para mais detalhes",
    "footerNote": "Novo conteúdo adicionado toda semana — fique ligado!",
    "trophiesAwardedPublicly": "Troféus entregues publicamente diante da comunidade",
    "startAdventure": "Começar a aventura",
    "categories": {
      "strategie": {
        "title": "Jogos de Estratégia",
        "description": "Reflexão e tática",
        "items": {
          "s1": {
            "title": "Awalé",
            "tagline": "A arte ancestral da estratégia",
            "detail": "Domine a arte ancestral do Awalé e desafie seus amigos em partidas estratégicas de rara intensidade. Cada semente plantada, cada captura decisiva o aproxima do topo do ranking. Os maiores táticos da Harmonia terão seu troféu entregue publicamente diante de toda a comunidade — porque a vitória merece ser consagrada às claras."
          },
          "s2": {
            "title": "Damas",
            "tagline": "Domine o tabuleiro, reine no palco",
            "detail": "Enfrente seus adversários em duelos de estratégia pura no tabuleiro. Antecipe cada movimento, domine cada troca e capture peças para subir no ranking da Harmonia. Os campeões são coroados publicamente — seu troféu, entregue diante de toda a comunidade, atesta uma excelência que impõe admiração."
          }
        }
      },
      "connaissance": {
        "title": "Jogos de Conhecimentos",
        "description": "Teste seu saber",
        "items": {
          "c1": {
            "title": "Verdadeiro ou Falso",
            "tagline": "Desafie seus amigos com fatos",
            "detail": "Teste a amplitude do seu conhecimento e desafie seus amigos em duelos intelectuais tão emocionantes quanto imprevisíveis. Responda Verdadeiro ou Falso com precisão e convicção, suba de nível e escale o ranking da Harmonia. Seus troféus serão entregues em público, diante de toda a comunidade — porque o conhecimento, no topo, merece sua coroa."
          }
        }
      },
      "arts": {
        "title": "Artes",
        "description": "Criatividade e expressão",
        "items": {
          "a1": {
            "title": "Fotografia",
            "tagline": "Seu olhar, sua assinatura",
            "detail": "A fotografia é um olhar sobre o mundo que só você possui. Envie suas fotos mais marcantes, chame a atenção da comunidade Harmonia e receba troféus entregues publicamente em homenagem ao seu olhar artístico excepcional. Na Harmonia, sua visão merece ser exposta, admirada e celebrada em seu justo valor."
          },
          "a2": {
            "title": "Desenho",
            "tagline": "Seu traço, seu universo",
            "detail": "Seu traço é sua assinatura, seu estilo é sua identidade. Compartilhe suas criações desenhadas com a comunidade Harmonia, emocione mentes e seja recompensado com troféus entregues publicamente em reconhecimento ao seu gênio criativo. A arte só vive por meio daqueles que têm a coragem de mostrá-la — e a Harmonia é o seu palco."
          },
          "a3": {
            "title": "Design",
            "tagline": "A estética a serviço da intenção",
            "detail": "O design é o encontro entre a estética e a intenção, entre a forma e o sentido. Exponha suas criações visuais mais ousadas na Harmonia, inspire sua comunidade e conquiste troféus entregues em público. Um grande designer merece um grande reconhecimento — e a Harmonia oferece a tribuna que você precisa."
          }
        }
      },
      "performance": {
        "title": "Performance",
        "description": "Suba ao palco",
        "items": {
          "p1": {
            "title": "Comédia",
            "tagline": "O riso, a arte mais universal",
            "detail": "O riso é o mais universal e precioso dos talentos humanos. Suba ao palco da Harmonia, emocione a comunidade com seu humor, seu senso de timing e sua presença de palco incomparável. Os melhores comediantes terão seus troféus entregues publicamente — porque fazer rir é uma arte que merece ser honrada diante de todos."
          },
          "p2": {
            "title": "Dança",
            "tagline": "Cada movimento conta uma história",
            "detail": "Cada movimento conta uma história que as palavras não podem expressar. Compartilhe seu talento de dançarino com a comunidade Harmonia — graça, potência, criatividade, emoção — e conquiste troféus entregues em público, em homenagem ao seu domínio absoluto do palco. A dança é uma linguagem universal: a Harmonia é o seu pódio."
          },
          "p3": {
            "title": "Teatro",
            "tagline": "Incorpore, cative, transcenda",
            "detail": "A arte dramática é a expressão mais profunda e justa da alma humana. Incorpore seus personagens com intensidade, cative sua plateia e faça de cada apresentação um momento inesquecível. Na Harmonia, os grandes atores de teatro são coroados publicamente — seu talento merece sua luz, sua ovação, sua consagração."
          }
        }
      },
      "musique": {
        "title": "Música",
        "description": "Faça o palco vibrar",
        "items": {
          "m1": {
            "title": "Canto",
            "tagline": "Sua voz, seu instrumento mais precioso",
            "detail": "Sua voz é seu instrumento mais precioso, seu timbre é sua marca no mundo. Seja em a cappella pura ou em performance acompanhada, deixe sua voz ressoar por toda a comunidade Harmonia. Os troféus são entregues em público — porque as grandes vozes merecem sua ovação, seu reconhecimento e sua luz."
          },
          "m2": {
            "title": "Piano",
            "tagline": "88 teclas, um universo infinito",
            "detail": "As 88 teclas do piano guardam um universo inteiro — da doçura melancólica às tempestades de paixão. Mostre seu virtuosismo, encante a comunidade Harmonia com a riqueza da sua interpretação e receba troféus entregues publicamente em reconhecimento ao seu domínio e sua sensibilidade musical excepcional."
          },
          "m3": {
            "title": "Violão",
            "tagline": "Cada acorde, uma declaração",
            "detail": "Seja acústico, elétrico ou clássico, o violão tem o poder de emocionar almas e transcender fronteiras. Compartilhe suas performances com a comunidade Harmonia — cada riff, cada solo, cada acorde o aproxima do topo. Seja coroado em cerimônias públicas de entrega de troféus, diante de todos."
          }
        }
      },
      "artisanat": {
        "title": "Artesanato",
        "description": "Saber-fazer e ofícios de excelência",
        "items": {
          "ar1": {
            "title": "Costura",
            "tagline": "A arte que veste o mundo",
            "detail": "A costura é uma arte milenar que veste o mundo com precisão e elegância. Mostre suas criações, sua atenção aos detalhes e seu domínio da agulha à comunidade Harmonia. Seus troféus serão entregues publicamente — porque a excelência do saber-fazer merece ser honrada, exposta e celebrada diante de todos."
          },
          "ar2": {
            "title": "Marcenaria",
            "tagline": "A madeira em suas mãos se torna obra",
            "detail": "A madeira em suas mãos se torna arquitetura, beleza e utilidade. Compartilhe suas realizações mais notáveis com a comunidade Harmonia e receba troféus entregues em público, em homenagem à nobreza do seu domínio artesanal. A marcenaria é uma arte exigente — a Harmonia presta a ela a homenagem que merece."
          },
          "ar3": {
            "title": "Cabeleireiro",
            "tagline": "Sublimar, transformar, revelar",
            "detail": "O trabalho de cabeleireiro transforma, embeleza e revela o que há de mais bonito nas pessoas. Apresente suas criações capilares mais ousadas à comunidade Harmonia e conquiste troféus entregues publicamente — porque a arte de embelezar o outro é um dom raro que merece seu mais belo e justo reconhecimento."
          },
          "ar4": {
            "title": "Solda",
            "tagline": "A precisão que une os metais",
            "detail": "A solda funde metais, engenhosidade e precisão em um único gesto dominado. Compartilhe sua expertise técnica e suas realizações mais impressionantes com a comunidade Harmonia. Seus troféus serão entregues em público — o rigor, a precisão e a excelência artesanal merecem sua coroa e reconhecimento."
          },
          "ar5": {
            "title": "Mecânica",
            "tagline": "A ciência que faz o mundo girar",
            "detail": "A mecânica é a ciência que literalmente faz o mundo girar. Demonstre sua expertise, compartilhe seus trabalhos técnicos mais elaborados com a comunidade Harmonia e receba troféus entregues publicamente em homenagem ao seu domínio excepcional de máquinas, motores e engenharia. A excelência mecânica merece seu pódio."
          }
        }
      }
    }
  }
}
